import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "report"
};
const _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_3 = {
  class: "menu-switch"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "content-box"
};
const _hoisted_6 = {
  class: "content-part"
};
const _hoisted_7 = {
  class: "content-part2"
};
const _hoisted_8 = {
  class: "ul-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Expand = _resolveComponent("Expand");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Fold = _resolveComponent("Fold");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", {
    class: "menu-switch under",
    onClick: _cache[0] || (_cache[0] = $event => $setup.menuStyle.width = '250px')
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Expand)]),
    _: 1
  })]), _createElementVNode("div", {
    class: "menu",
    style: _normalizeStyle($setup.menuStyle)
  }, [_createElementVNode("p", _hoisted_3, [_createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = $event => $setup.menuStyle.width = 0)
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Fold)]),
    _: 1
  })]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Expand)]),
    _: 1
  }, 512), [[_vShow, false]])]), _cache[3] || (_cache[3] = _createStaticVNode("<ul data-v-fec3db76><li data-v-fec3db76>一、总体表现</li><li data-v-fec3db76>您的测试结果</li><li data-v-fec3db76>您本次测试结果在系统数据中的位置</li></ul><ul data-v-fec3db76><li data-v-fec3db76>二、各语法项表现</li><li data-v-fec3db76>您需要提升的语法项</li><li data-v-fec3db76>您的各语法项得分</li></ul><ul data-v-fec3db76><li data-v-fec3db76>三、诊断轨迹</li></ul><ul data-v-fec3db76><li data-v-fec3db76>四、 Dr. U 的建议</li><li data-v-fec3db76>从最需要提升的语法项入手</li><li data-v-fec3db76>确定下一步学习目标</li><li data-v-fec3db76>语法学习资源推荐</li><li data-v-fec3db76>语法练习推荐</li></ul>", 4))], 4)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "content-title"
  }, [_createElementVNode("p", null, "大学生英语能力诊断报告"), _createElementVNode("p", null, "听力技能个人报告")], -1)), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "content-info"
  }, [_createElementVNode("p", null, "测11同学："), _createElementVNode("p", null, " 您好！以下是您本次听力诊断测试的表现报告。您可根据这份报告了解您目前的英语听力能力总体水平、听力微技能等分项表现以及诊断轨迹，并可获得学习建议，从而明确下一步的学习目标，制定学习计划。（报告蓝色文字均可点击查看）在开始使用报告前请先了解以下信息： "), _createElementVNode("p", null, " 优诊学大学生英语能力诊断系统是依据《中国英语能力等级量表》、参考《大学英语教学指南（2020版）》等教学指导性文件开发研制。《中国英语能力等级量表》（以下简称“量表”）在研制阶段采集了已有教学大纲和各类大规模考试大纲的描述语，经过严谨的研究过程后应用于各级别能力的描述。优诊学测试目的在于诊断学生各技能在量表相应级别上的能力表现。学生可根据诊断报告并参考量表级别与教学要求和主要测试的对应关系，更为准确和个性化地设定学习目标，进而提升英语能力以及在各类语言测试评价中的表现。 ")], -1)), _createElementVNode("div", _hoisted_6, [_cache[7] || (_cache[7] = _createElementVNode("p", {
    class: "title-1"
  }, "一、总体表现", -1)), _createElementVNode("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("p", {
    class: "title-2"
  }, "您的测试结果", -1)), _withDirectives(_createVNode(_component_el_table, {
    data: $setup.tableData
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "姓名"
    }), _createVNode(_component_el_table_column, {
      prop: "level",
      label: "能力级别"
    }), _createVNode(_component_el_table_column, {
      prop: "score",
      label: "能力得分"
    })]),
    _: 1
  }, 8, ["data"]), [[_vShow, $setup.levelTableSwitch]]), _createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_cache[4] || (_cache[4] = _createTextVNode(" 听力诊断测试中能力分为4、5、6、7四个级别。 ", -1)), _createElementVNode("span", {
    onClick: _cache[2] || (_cache[2] = $event => $setup.levelTableSwitch = !$setup.levelTableSwitch)
  }, "级别参考表")]), _cache[5] || (_cache[5] = _createElementVNode("li", null, "各级别能力得分的总分均为100分。", -1))]), _withDirectives(_createVNode(_component_el_table, {
    data: $setup.levelTableData
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "level",
      label: "等级"
    }), _createVNode(_component_el_table_column, {
      prop: "cseLevel",
      label: "CSE等级"
    }), _createVNode(_component_el_table_column, {
      prop: "test",
      label: "国内考试"
    })]),
    _: 1
  }, 8, ["data"]), [[_vShow, $setup.levelTableSwitch]])]), _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"content-part2\" data-v-fec3db76><p class=\"title-2\" data-v-fec3db76>您的听力能力总体描述</p><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76>您目前的英语听力能力处于4级水平，该级别的学生可以做到：</li><li data-v-fec3db76> • 能听懂语速正常的日常对话和讨论，获取重要信息，理解说话者的观点和意图； </li><li data-v-fec3db76> • 能听懂语速正常、话题熟悉、与个人兴趣相关的口头表达，如指示说明、非专业性讲座、新闻报道等，获取相关信息，理解主要内容。 </li></ul><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76>您能基本听懂该级别的听力材料。但是，</li><li data-v-fec3db76>• 您在理解主旨大意微技能上表现有待提高；</li><li data-v-fec3db76>• 您需关注英文讲座的听力材料并加强相关听力练习；</li></ul></div><div class=\"content-part2\" data-v-fec3db76><p class=\"title-2\" data-v-fec3db76>您在班级的位置</p><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76> 目前班级已有1人完成测试，您排在第1位。下图是您在班级中的百分比位置。 </li></ul><div class=\"charts\" data-v-fec3db76><div id=\"level-box\" style=\"height:200px;\" data-v-fec3db76></div><span class=\"user-point\" data-v-fec3db76></span></div><ul class=\"ul-2\" data-v-fec3db76><li data-v-fec3db76> 百分比的计算结果会随着全班作答情况实时更新，个人最终百分比位置以全班考试截止后的数据为准。 </li></ul></div>", 2))]), _cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "content-part"
  }, [_createElementVNode("p", {
    class: "title-1"
  }, "二、分项表现"), _createElementVNode("ul", {
    class: "ul-1"
  }, [_createElementVNode("li", null, " 本部分展示了您在本次4级测试中微技能、体裁和话题三方面的分项表现： ")]), _createElementVNode("div", {
    class: "content-part2"
  }, [_createElementVNode("p", {
    class: "title-2"
  }, "您的微技能表现"), _createElementVNode("ul", {
    class: "ul-1"
  }, [_createElementVNode("li", null, " 下图展示了您本次测试中微技能的表现。请您关注弱项微技能并设定合理的学 ")]), _createElementVNode("div", {
    class: "charts"
  }, [_createElementVNode("div", {
    id: "skill-bat-box"
  })]), _createElementVNode("ul", {
    class: "ul-2"
  }, [_createElementVNode("li", null, "每项微技能满分为30分。各项表现按照从弱到强的顺序排列。"), _createElementVNode("li", null, " 鼠标移至相应的微技能，可查看各微技能的能力详细描述和样题。 ")]), _createElementVNode("p", {
    class: "title-3"
  }, "★ 弱项微技能的典型题目"), _createElementVNode("ul", {
    class: "ul-1"
  }, [_createElementVNode("li", null, "以下是您弱项微技能中的一道典型题目"), _createElementVNode("li", null, "考查微技能： 理解主旨大意"), _createElementVNode("li", null, [_createTextVNode(" 音频回顾： "), _createElementVNode("audio", {
    src: "https://cdn-oss-unilearn.fltrp.com/ib/f6c03014-27a1-4815-8c04-4efb33596fb6/7d865e7a-06db-4b1f-b09c-e562a1ec5bcd.mp3",
    controlslist: "nodownload",
    controls: "controls"
  })]), _createElementVNode("li", null, "题 目： What is the man doing?"), _createElementVNode("li", null, "A. Asking for salt."), _createElementVNode("li", null, "B. Changing his order."), _createElementVNode("li", null, "答案： D"), _createElementVNode("li", null, "题目解析："), _createElementVNode("li", null, " 本题考查“理解主旨大意”的能力，要求能听懂学校生活、日常休闲过程中经常遇到的发言或谈话的主要内容。答题时需要总体了解音频涉及的信息及主题。 对话围绕对食物的评价展开，在被服务生问到如何评价餐食时，男士直接给出了否定的回答，并补充道：“Everything has too much salt on it. It's making me sick.”。由此可知男士对所上的餐非常不满，是在向服务生抱怨。 因此答案是D。 ")])]), _createElementVNode("div", {
    class: "content-part2"
  }, [_createElementVNode("p", {
    class: "title-2"
  }, "您的体裁表现"), _createElementVNode("ul", {
    class: "ul-1"
  }, [_createElementVNode("li", null, " 下图展示了您本次测试中体裁方面的表现。您可根据图中数据来了解不同体裁对您听力能力的影响，并进行针对性的听力训练。 ")]), _createElementVNode("div", {
    class: "charts"
  }, [_createElementVNode("div", {
    id: "genre-bat-box"
  })]), _createElementVNode("ul", {
    class: "ul-2"
  }, [_createElementVNode("li", null, "按照得分率从低到高的顺序排列。")])]), _createElementVNode("div", {
    class: "content-part2"
  }, [_createElementVNode("p", {
    class: "title-2"
  }, "您的话题表现"), _createElementVNode("ul", {
    class: "ul-1"
  }, [_createElementVNode("li", null, "在本次测试所涉及到的话题中："), _createElementVNode("li", null, "• 您在“日常活动”相关话题方面表现较弱")])])], -1)), _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"content-part\" data-v-fec3db76><p class=\"title-1\" data-v-fec3db76>三、诊断轨迹</p><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76> 下图展示了您在历次诊断测试中听力能力的表现，您可据此了解自己听力能力的发展情况。 </li></ul></div><div class=\"content-part\" data-v-fec3db76><p class=\"title-1\" data-v-fec3db76>四、 Dr. U 的建议</p><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76> 诊断测试旨在帮助您更准确地了解自己的英语学习情况，并据此制定相应的学习计划和目标。以下是根据本次听力诊断测试结果，Dr. U为您提出的建议： </li></ul><div class=\"content-part2\" data-v-fec3db76><p class=\"title-2\" data-v-fec3db76>掌握听力策略</p><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76>• 基于您在微技能方面的表现</li><li data-v-fec3db76> 针对您的弱项理解主旨大意，建议您加强概括主题策略方面的学习和训练，包括： </li><li data-v-fec3db76>1） 根据关键词和语篇特征，确定信息的重点，获取主旨大意；</li><li data-v-fec3db76> 2） 在听的过程中，特别关注所听材料中涉及主题的信息（常常是首句或尾句，也可能在材料中反复出现）； </li></ul><ul class=\"ul-1\" data-v-fec3db76><li data-v-fec3db76>• 基于您在体裁方面的表现</li><li data-v-fec3db76> 您最需要加强练习的体裁为讲座。 讲座信息量大、逻辑性强、条理清晰，由主讲人精心组织。讲座的开头和结尾有相对固定的形式：开头的目的是引入主题；结尾时，主讲人会回顾所讲内容，做简要的概括总结，有时也会为下一次讲座提出思考问题等。根据讲座的特点，建议您： </li></ul></div></div>", 2))])])]);
}